import React from 'react';
import { Form, Field, Button, TextInput } from 'shared';
import useModal from 'hooks/useModal';
import Modal from 'modals/layout';
import {
  configureIntegration,
  selectIntegrationById
} from 'store/integrations';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { IntegrationID } from '__types__';
import { displayAlert } from 'store/v1/ui/ui.actions';

const ConfigureNetSuiteModal = () => {
  const dispatch = useDispatch();
  const { cancelModal, closeModal } = useModal();
  const integration = useSelector(state =>
    selectIntegrationById(state, IntegrationID.NETSUITE)
  );
  const initialValues = {
    master_projects_api_url: '',
    purchase_order_api_url: '',
    realm: '',
    consumerKey: '',
    consumerSecret: '',
    tokenKey: '',
    tokenSecret: '',
    ...integration?.configuration
  };

  const handleSubmit = data => {
    const configuration = {
      ...data
    };
    dispatch(
      configureIntegration({
        id: IntegrationID.NETSUITE,
        enabled: integration ? integration.enabled : true,
        configuration
      })
    )
      .then(unwrapResult)
      .then(_ => {
        dispatch(displayAlert('success', 'NetSuite integration configured'));
        closeModal();
      });
  };

  return (
    <Form values={initialValues} onSubmit={handleSubmit}>
      <Modal size="m">
        <Modal.Header title="Configure NetSuite integration" />
        <Modal.Content>
          <Modal.Scrollable>
            <div className="stack-s">
              <Field
                label="Master Projects API URL"
                name="master_projects_api_url"
                isRequired
              >
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field
                label="Purchase Order API URL"
                name="purchase_order_api_url"
                isRequired
              >
                <TextInput placeholder="" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Realm" name="realm" isRequired>
                <TextInput placeholder="Realm" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Consumer Key" name="consumerKey" isRequired>
                <TextInput placeholder="Consumer key" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Consumer Secret" name="consumerSecret" isRequired>
                <TextInput placeholder="Consumer Secret" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Token Key" name="tokenKey" isRequired>
                <TextInput placeholder="Token Key" />
              </Field>
            </div>
            <div className="stack-s">
              <Field label="Token Secret" name="tokenSecret" isRequired>
                <TextInput placeholder="Token Secret" />
              </Field>
            </div>
          </Modal.Scrollable>
          <Modal.Toolbar>
            <Button label="Cancel" action={cancelModal} />
            <Button
              label="Save changes"
              icon="tick"
              appearance="primary"
              hasMarginLeft
              isLoading={false}
              action="submit"
            />
          </Modal.Toolbar>
        </Modal.Content>
      </Modal>
    </Form>
  );
};

export default ConfigureNetSuiteModal;
